export default "__VITE_ASSET__BKNu6_K5__"